module.exports = __webpack_public_path__ + "img/microsoft-edge.2f036616.png";